import { arrayOf, number, shape, string } from "prop-types";

const creativePropTypes = shape({
  alt_text: string,
  id: number,
  image_url: string,
  min_height: number,
  max_height: number,
  width: number
});

export const segmentTargetsPropTypes = shape({
  creatives: arrayOf(creativePropTypes),
  segment_target_id: number,
  url: string
});

export const cmsPlacementsPropType = arrayOf(
  shape({
    machine_name: string,
    segment_targets: arrayOf(segmentTargetsPropTypes)
  })
);
